<template>
    <div>
        <Table  :columns="Columns" :data="List.body" :loading="loading"></Table>
        <div  class="page-box">
            <Page :total="List.page.count" :page-size="page_size" :page-num="page_num" @on-change="change_page" v-if="List.page" />
        </div>
        <Modal
                v-model="showDetail"
                title="镜像名称"
                width="700"
        >
            <Form>
                <FormItem label="镜像名称">
                    {{detailData.name}}
                </FormItem>
                <FormItem label="类型">
                    {{detailData.img_type}}
                </FormItem>
                <FormItem label="备注">
                    {{detailData.remark}}
                </FormItem>
                <FormItem :label="value" v-for="(value,key) in detailData.languages" :key="value" v-show="env_mod_list[key].length > 0">
                    <Table border :columns="Column" :data="item" v-for="(item) in env_mod_list[key]"></Table>
                </FormItem>


            </Form>
        </Modal>
    </div>
</template>
<script>
    import {mapState,mapActions} from 'vuex'
    import moment from 'moment'
    export default {
        name:"private",
        props:{
            getList:Function,
            loading:{
                type:Boolean,
                default:false,
            },
        },
        data(){
            return {
                currentPage:'Public',
                page_num:1,
                page_size:50,
                showDetail:false,
                create_dataSet:false,
                Column:[
                    {
                        title: 'mod',
                        key: 'mod'
                    },
                    {
                        title: 'oper',
                        key: 'oper'
                    },
                    {
                        title: 'ver',
                        key: 'ver'
                    }
                ],
                env_mod_list:[],
                detailData:{
                    'name':'',
                    'img_type':''
                },

                Columns:[
                    {
                        title:'ID',
                        key:'id',
                        width:65,
                        tooltip:true,
                        sortable: true
                    },
                    {
                        title:'镜像名称',
                        key:'name'
                    },
                    {
                        title:'镜像类型',
                        key:'img_type',
                    },
                    {
                        title:'创建时间',
                        key:'ctime',
                        render: (h, params) => {
                            return h('div', [
                                h('span', {
                                }, moment(params.row.ctime).format('YYYY-MM-DD HH:mm:ss')),
                            ]);
                        }
                    },
                    {
                        title:'操作',
                        key:'action',
                        render:(h,params)=>{
                            return h('div',[
                                h('a', {
                                    style: {
                                        marginRight: '5px',
                                        color:'#029ff6'
                                    },
                                    on: {
                                        click: () => {
                                            this.getDetail(params.row.id);
                                        }
                                    }
                                }, '查看'),
                            ])
                        }
                    }
                ]
            }
        },
        methods:{
            ...mapActions({
                getPublicImageInfo:'images/getPublicImageInfo',
            }),
            create(){
                this.$router.push({
                    name: 'createImages',
                })
            },
            getDetail(id){
                let _this = this;
                this.getPublicImageInfo({
                    id:id,
                    callback:res=>{
                        _this.detailData = res;
                        let env_mod = JSON.parse(res.env_mod);
                        _this.detailData.languages.forEach((v,key)=>{
                            _this.env_mod_list[key] = [];
                            if(env_mod[v] !==undefined && env_mod[v].length >0){
                                _this.env_mod_list[key].push(env_mod[v])
                            }
                        });
                    },
                    error:msg=>{}
                });
                this.showDetail = true;
            },
            // 翻页
            change_page(page){
                this.page_num = page;
                this.getLists();
            },
            getLists(){
                let _this = this;
                this.getList(_this.currentPage,{
                    sort:'ctime',
                    channel:1,
                    page_num:_this.page_num,
                    page_size:_this.page_size
                });
            }
        },
        computed: {
            ...mapState({
                List:state => state.images.publicList,
            }),
            isShow(state){
                if(state.create_dataSet == false){
                    return true
                }else{
                    return false
                }
            }
        },
        mounted() {
            this.getLists();
        }
    }
</script>
